import { z } from "zod";
import { urlSchema } from "../../utils/codecUtils.schema";

export const relationTypeSchema = z.union([
  z.literal('export'),
  z.literal('einvoice'),

]);

export const relationSchema = z.object({
  id: z.number(),
  type: relationTypeSchema,
  key: z.string().nullable(),
  annotation: urlSchema,
  documents: z.array(urlSchema),
  url: urlSchema
});
